module.exports = __webpack_public_path__ + "static/control-580debfa7b5a0074bae69622cac76a83.jpg";